/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 2015:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 2151:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(5772);
var THEMES = {
  MP: 'mercadopago',
  ML: 'mercadolibre'
  // ME: 'mercadoenvios',
  // MS: 'mercadoshops',
  // MA: 'mercadoads',
  // MC: 'mercadocreditos',
};
var THEMES_FLATNAMES = Object.values(THEMES);
module.exports = {
  THEMES: THEMES,
  THEMES_FLATNAMES: THEMES_FLATNAMES
};

/***/ }),

/***/ 2971:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 5179:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  CD: () => (/* reexport */ CONSUMERS),
  no: () => (/* reexport */ CONSUMERS_FLAT_NAMES),
  VU: () => (/* reexport */ CalmContext),
  FN: () => (/* reexport */ CalmProvider),
  uj: () => (/* reexport */ useCalmContext)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2015);
;// ./components/contexts/calm/src/context.js


/**
 * Calm context
 * Shares common information among the different lib components
 */
var CalmContext = /*#__PURE__*/(0,external_react_.createContext)();

/**
 * useCalmContext
 * Hook to access the CALM shared information from components and adapt behavior to it
 */
var useCalmContext = function useCalmContext() {
  return (0,external_react_.useContext)(CalmContext);
};
// EXTERNAL MODULE: external "@babel/runtime/helpers/jsx"
var jsx_ = __webpack_require__(2971);
var jsx_default = /*#__PURE__*/__webpack_require__.n(jsx_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(9825);
// EXTERNAL MODULE: ./utils/constants/themes.js
var themes = __webpack_require__(2151);
// EXTERNAL MODULE: external "core-js/modules/es.object.values.js"
var es_object_values_js_ = __webpack_require__(5772);
;// ./components/contexts/calm/src/constants.js

var CONSUMERS = {
  renderer: 'calm-renderer',
  admin: 'calm-admin'
};
var CONSUMERS_FLAT_NAMES = Object.values(CONSUMERS);
;// ./components/contexts/calm/src/provider.js







/**
 * CalmProvider
 * Stores information that should be shared among sections and where the component is being consumed.
 */
var CalmProvider = function CalmProvider(_ref) {
  var children = _ref.children,
    context = _ref.context;
  return /*#__PURE__*/jsx_default()(CalmContext.Provider, {
    value: context
  }, void 0, children);
};
;// ./components/contexts/calm/src/index.js




/***/ }),

/***/ 5772:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.object.values.js");

/***/ }),

/***/ 9825:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 9978:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  LM: () => (/* reexport */ MELIDATA_MODE_CLEAN_SEND),
  jR: () => (/* reexport */ MELIDATA_MODE_SEND),
  um: () => (/* reexport */ TRACKING_TRIGGERS),
  fu: () => (/* reexport */ TrackingContext),
  J0: () => (/* reexport */ provider),
  JP: () => (/* reexport */ buildTracks),
  v5: () => (/* reexport */ getDefaultEventTrackingFn),
  Fb: () => (/* reexport */ getShowTrackingFn),
  z1: () => (/* reexport */ useTracking)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2015);
;// ./components/contexts/tracking/src/context.js


/**
 * TrackingContext
 * Saves the Tracking instance that is used by the provider
 */
var TrackingContext = /*#__PURE__*/(0,external_react_.createContext)();

/**
 * useTracking
 * Hook to access the Tracking context and communicate to tracking handler instance
 */
var useTracking = function useTracking() {
  return (0,external_react_.useContext)(TrackingContext);
};
// EXTERNAL MODULE: external "@babel/runtime/helpers/jsx"
var jsx_ = __webpack_require__(2971);
var jsx_default = /*#__PURE__*/__webpack_require__.n(jsx_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(9825);
;// ./components/contexts/tracking/src/provider.js





/**
 * Tracking Provider
 * Stores an instance to a Tracking Handler object with methods to invoke Melidata functions.
 * CALM lib sections link events on their elements
 */

var TrackingProvider = function TrackingProvider(_ref) {
  var children = _ref.children,
    trackHandler = _ref.trackHandler;
  return /*#__PURE__*/jsx_default()(TrackingContext.Provider, {
    value: trackHandler
  }, void 0, children);
};
/* harmony default export */ const provider = (TrackingProvider);
;// external "@babel/runtime/helpers/objectSpread2"
const objectSpread2_namespaceObject = require("@babel/runtime/helpers/objectSpread2");
var objectSpread2_default = /*#__PURE__*/__webpack_require__.n(objectSpread2_namespaceObject);
;// ./components/contexts/tracking/src/helpers.js

var getDefaultEventTrackingFn = function getDefaultEventTrackingFn() {
  var handler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (ev, trackData) {
    var customTrackdata = trackData.customTrackdata,
      calmTrackdata = trackData.calmTrackdata;
    if (!handler.notifyTrack && !handler.notifyMultipleTracks) {
      return;
    }
    try {
      if ('melidata' in customTrackdata || 'gtm' in customTrackdata) {
        handler.notifyMultipleTracks(customTrackdata, calmTrackdata);
      } else {
        handler.notifyTrack(customTrackdata, calmTrackdata);
      }
    } catch (err) {
      /* eslint-disable no-console */
      /* istanbul ignore next */
      console.error('ERROR: ', err);
      /* eslint-enable no-console */
    }
  };
};
var getShowTrackingFn = function getShowTrackingFn() {
  var handler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (trackData) {
    try {
      handler.notifyShowTrack(trackData);
    } catch (err) {
      /* eslint-disable no-console */
      /* istanbul ignore next */
      console.error('ERROR: ', err);
      /* eslint-enable no-console */
    }
  };
};
var buildTracks = function buildTracks(trackdata, element, sectionMetadata) {
  var customTrackdata = objectSpread2_default()({}, trackdata || {});
  var calmTrackdata = objectSpread2_default()(objectSpread2_default()({}, sectionMetadata || {}), {}, {
    conversion: (trackdata === null || trackdata === void 0 ? void 0 : trackdata.conversion) || false,
    element: element
  });
  return {
    customTrackdata: customTrackdata,
    calmTrackdata: calmTrackdata
  };
};
;// ./components/contexts/tracking/src/constants.js
var LEXICAL_LINK_CLASS = 'lexical-link';
var LEXICAL_LINK_TEXT_LIMIT = 100;
var MELIDATA_MODE_SEND = 'send';
var MELIDATA_MODE_CLEAN_SEND = 'cleanAndSend';
var TRACKING_TRIGGERS = {
  BRAND: 'brand',
  BUTTON_ALTERNATIVE: 'button alternative',
  BUTTON_ERROR: 'button error',
  BUTTON_PRIMARY: 'button primary',
  BUTTON_SUCCESS: 'button success',
  CARD_LINK: 'card link',
  FAQ: 'FAQ',
  HOME_LINK: 'home link',
  HYPERLINK: 'hyperlink',
  SLIDE: 'slide',
  SHORTCUT: 'shortcut',
  SUBMIT_ERROR: 'submit error',
  SUBMIT_FORM: 'submit form',
  SUBMIT_SUCCESS: 'submit success',
  VIDEO: 'play video'
};
;// ./components/contexts/tracking/src/index.js





/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CONSUMERS: () => (/* reexport safe */ _components_contexts_calm_src_index__WEBPACK_IMPORTED_MODULE_0__.CD),
/* harmony export */   CONSUMERS_FLAT_NAMES: () => (/* reexport safe */ _components_contexts_calm_src_index__WEBPACK_IMPORTED_MODULE_0__.no),
/* harmony export */   CalmContext: () => (/* reexport safe */ _components_contexts_calm_src_index__WEBPACK_IMPORTED_MODULE_0__.VU),
/* harmony export */   CalmProvider: () => (/* reexport safe */ _components_contexts_calm_src_index__WEBPACK_IMPORTED_MODULE_0__.FN),
/* harmony export */   MELIDATA_MODE_CLEAN_SEND: () => (/* reexport safe */ _components_contexts_tracking_src__WEBPACK_IMPORTED_MODULE_1__.LM),
/* harmony export */   MELIDATA_MODE_SEND: () => (/* reexport safe */ _components_contexts_tracking_src__WEBPACK_IMPORTED_MODULE_1__.jR),
/* harmony export */   TRACKING_TRIGGERS: () => (/* reexport safe */ _components_contexts_tracking_src__WEBPACK_IMPORTED_MODULE_1__.um),
/* harmony export */   TrackingContext: () => (/* reexport safe */ _components_contexts_tracking_src__WEBPACK_IMPORTED_MODULE_1__.fu),
/* harmony export */   TrackingProvider: () => (/* reexport safe */ _components_contexts_tracking_src__WEBPACK_IMPORTED_MODULE_1__.J0),
/* harmony export */   buildTracks: () => (/* reexport safe */ _components_contexts_tracking_src__WEBPACK_IMPORTED_MODULE_1__.JP),
/* harmony export */   getDefaultEventTrackingFn: () => (/* reexport safe */ _components_contexts_tracking_src__WEBPACK_IMPORTED_MODULE_1__.v5),
/* harmony export */   getShowTrackingFn: () => (/* reexport safe */ _components_contexts_tracking_src__WEBPACK_IMPORTED_MODULE_1__.Fb),
/* harmony export */   useCalmContext: () => (/* reexport safe */ _components_contexts_calm_src_index__WEBPACK_IMPORTED_MODULE_0__.uj),
/* harmony export */   useTracking: () => (/* reexport safe */ _components_contexts_tracking_src__WEBPACK_IMPORTED_MODULE_1__.z1)
/* harmony export */ });
/* harmony import */ var _components_contexts_calm_src_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5179);
/* harmony import */ var _components_contexts_tracking_src__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9978);
/* harmony import */ var _utils_constants_themes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2151);
/* harmony import */ var _utils_constants_themes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_utils_constants_themes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _utils_constants_themes__WEBPACK_IMPORTED_MODULE_2__) if(["default","CONSUMERS","CONSUMERS_FLAT_NAMES","CalmContext","CalmProvider","useCalmContext","MELIDATA_MODE_CLEAN_SEND","MELIDATA_MODE_SEND","TRACKING_TRIGGERS","TrackingContext","TrackingProvider","buildTracks","getDefaultEventTrackingFn","getShowTrackingFn","useTracking"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _utils_constants_themes__WEBPACK_IMPORTED_MODULE_2__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);



})();

module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=index.production.js.map